import { BcMath } from '@golden/bcmath';
import { debounceTime, filter, switchMap } from 'rxjs';
import { computed } from 'vue';
import { goldenCashFormat } from '@golden/shared';
import { useObservable } from './useObservable';
import { useWatchObservable } from './useWatchObservable';
import { useGDKErrorAlert } from './useGDKFetch';
export const useDepositFee = (options) => {
    const { payload, handleError = useGDKErrorAlert(), observable, validator, cashFormat = goldenCashFormat } = options;
    const original = useObservable(useWatchObservable(() => payload.value.cash).pipe(filter(({ newVal }) => validator(newVal)), debounceTime(250), switchMap((data) => observable({
        cash: data.newVal,
        account: payload.value?.account,
        nickname: payload.value?.nickname,
        category: payload.value.category,
        method: payload.value.method,
        client: payload.value?.client
    }))), null, handleError);
    const fee = computed(() => !original.value?.fee || !Number(payload.value.cash) ? '-' : cashFormat(original.value.fee));
    const predict = computed(() => validator(payload.value.cash) && fee.value !== '-'
        ? cashFormat(BcMath.base(payload.value.cash).sub(fee.value).get())
        : '-');
    return {
        fee,
        predict
    };
};
//# sourceMappingURL=useDepositFee.js.map